import React from 'react'
import { Container, FindLink, StyledText } from './common/MyPracticeStyles'
import { Box } from 'ui/acro'

const MyPracticeNotData = ({ option, text }) => {
  const getFindLink = () => {
    let linkText = ''
    let link = ''

    if (option === 'programs') {
      linkText = 'Explore our library'
      link = '/explore/filter'
    } else if (option === 'classes') {
      linkText = 'Find a class'
      link = '/class-finder'
    }

    if (option === 'completed') {
      return (
        <Box
          fontFamily='Proxima'
          fontSize='16px'
          fontWeight='500'
          mt='1rem'
          style={{ textTransform: 'uppercase' }}
        >
          Find a &nbsp;
          <FindLink as='a' href='/class-finder'>
            class
          </FindLink>
          &nbsp;or &nbsp;
          <FindLink as='a' href='/explore/filter'>
            program
          </FindLink>
        </Box>
      )
    } else {
      return (
        <FindLink as='a' href={link} alignSelf='flex-center'>
          {linkText}
        </FindLink>
      )
    }
  }

  return (
    <Container>
      {!text && (
        <StyledText>
          You haven't saved any {option.toUpperCase()} yet.
        </StyledText>
      )}
      {text && <StyledText>{text}</StyledText>}

      {getFindLink()}
    </Container>
  )
}

export default MyPracticeNotData
